module.exports = __webpack_public_path__ + "static/media/Papandopulijana mladih umjetnika 3.dcd24a74.jpg";